export function getAsPages<T>(items: T[], itemsPerPage: number): { page: number, items: T[] }[] {
    const totalPages = Math.ceil(items.length / itemsPerPage);
    const pages: { page: number, items: T[] }[] = [];
  
    for (let i = 0; i < totalPages; i++) {
      const startIndex = i * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const currentPageItems = items.slice(startIndex, endIndex);
  
      pages.push({
        page: i + 1,
        items: currentPageItems
      });
    }
  
    return pages;
}

export function groupBy<T>(list:T[], grouper: (a:T)=>string):Record<string, T[]>{
    let result:Record<string, T[]> = {};
    for(var i in list){
        let element = list[i];
        let key = grouper(element);
        if(key in result){
            result[key].push(element);
            continue;
        }
        result[key] = [element];
    }
    return result;
}

export function remap<T, V>(map:Record<string, T>, mapper:(item: T) => V){
    var result:Record<string, V> = {}
    Object.entries(map).forEach(([k, v]) => result[k] = mapper(v));
    return result;
}

export async function sleep(time:number){
    return await (new Promise((ok) =>{
        setTimeout(ok, time);
    }));
}